import axios from 'axios'
import qs from 'qs'

const wpAxios = axios.create()

export default ({ method = 'GET', url, data = {} }) => {
  return wpAxios.post('/wp-admin/admin-ajax.php', qs.stringify({
    action: 'api_request',
    method,
    url,
    data
  }))
}
